import React, { Fragment } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import AbstractComponent from './component/AbstractComponent';
import ModalAlerta from './component/layout/modal/ModalAlerta';
import TopNav from './component/layout/nav/TopNav';
import SideNav from './component/layout/nav/SideNav';
import Preload from './component/layout/preload/PreloadContent';
import NaoEncontrado from './component/naoencontrado/NaoEncontrado';
import Sistema from './component/configuracao/sistema/Sistema';
import Login from './component/login/Login';
import Register from './component/cliente/Register';
import TemaPesquisa from './component/configuracao/tema/Tema';
import TemaCadastro from './component/configuracao/tema/Cadastro';
import FormasPagamentoPesquisa from './component/configuracao/formas-pagamento/FormasPagamento';
import FormasPagamentoCadastro from './component/configuracao/formas-pagamento/Cadastro';
import Pedido from './component/pedido/Pedido';
import PedidoView from './component/pedido/View';

import NotificacaoPesquisa from './component/notificacao/NotificacaoPesquisa';
import NotificacaoCadastro from './component/notificacao/NotificacaoCadastro';
import ModalSelectCliente from './component/cliente/ModalSelectCliente';

import AutenticarService from './service/AutenticarService';
import MenuService from './service/MenuService';
import UsuarioService from './service/UsuarioService';
import UsuarioClienteService from './service/UsuarioClienteService';
import SistemaService from './service/SistemaService';

import { getAppDir } from './helper/Url';

import './css/conectividade.css';

class Admin extends AbstractComponent {
    constructor(props) {
        super(props);        

        this.state = {   
            textoAlerta: '',

            preload1: false,      

            preload2: false,
            
            erro: {
                message: '',
                code: 0
            },

            modalSelectCliente: false,

            titulo: '',                       
            
            clientes: [],

            menu: [],
            
            usuario: {
                id: 0,

                nome: '',

                email: '',

                avance: 0,

                admin: 0,

                empresa: {
                    id: 0,
                    cnpj: '',
                    nome: ''                    
                }
            }
        };                     
    }                           

    reloadPage() {                   
        setInterval(function() {                                                                 
            document.location.reload(false);            
            window.location.reload(false);                            
        }, 1000 * 60 * 60 * 24);
    }  

    updateEmpresa(empresa) {
        let usuario = this.state.usuario;

        usuario.empresa = empresa;

        this.setState({
            usuario: usuario,
            modalSelectCliente: false
        });
        
        window.location.reload(true);        
        AutenticarService.setIdEmpresa(empresa.id);  
        AutenticarService.setCnpjEmpresa(empresa.cnpj);      
    }

    getMenu() {        
        MenuService.listar(
            this.state.usuario.admin
        ).then(resposta => {
            this.setState({
                menu: resposta.data,
                preload2: false
            });
        }).catch(() => {
            this.setState({preload2:false});
        });
    }

    getUsuario() {
        this.setState({preload2: true});

        UsuarioService.get(
            AutenticarService.getToken()
        ).then(resposta => {
            let usuario = this.state.usuario;

            usuario.id = resposta.data.id;
            usuario.nome = resposta.data.nome;
            usuario.email = resposta.data.email;
            usuario.admin = resposta.data.admin;
            usuario.avance = resposta.data.avance;            

            this.setState({ usuario: usuario });

            this.getMenu();
        }).catch(erro => {
            this.setState({
                erro: this.trataErro(erro),
                preload2: false
            });
        });
    }

    getEmpresa() {
        if(AutenticarService.getIdEmpresa() === 0) {  
            this.setState({preload1: false});          
            return ;
        }

        SistemaService.buscarById(
            AutenticarService.getIdEmpresa()
        ).then(resposta => {
            let usuario = this.state.usuario;
            let empresa = usuario.empresa;

            empresa.id = resposta.data.id;
            empresa.cnpj = resposta.data.cnpj;
            empresa.nome = resposta.data.nome_app;

            usuario.empresa = empresa;

            this.setState({
                usuario: usuario,
                preload1: false
            });            
        }).catch(() => {
            this.setState({preload1: false});
        });
    }

    buscaUsuarioCliente() {
        this.setState({
            preload1: true
        });

        UsuarioClienteService.cliente(
            AutenticarService.getToken()
        ).then(resposta => {
            const clientes = [{valor: 0, texto: 'Selecione'}];

            resposta.data.map(item => {
                clientes.push({empresa: item,
                            valor: item.id, 
                            texto: item.nome, 
                            selected: (parseInt(item.id, 10) === parseInt(this.props.editarId, 10))
                })
                
                return item;
            });

            if(resposta.data.length === 1) {
                AutenticarService.setIdEmpresa(resposta.data[0].id);
                AutenticarService.setCnpjEmpresa(resposta.data[0].cnpj);
            }

            this.setState({ clientes: clientes });   
            
            this.getEmpresa();         
        }).catch(erro => {
            this.setState({
                erro: this.trataErro(erro),
                preload1: false
            });
        })
    }

    componentDidMount() {  
        this.buscaUsuarioCliente();
        this.getUsuario();
    }

    inPreload() {        
        return this.state.preload1 || 
               this.state.preload2;
    }

    showComponent() {
        if(this.inPreload()) {
            return (
                <Fragment>
                    <Preload show={true} />
                </Fragment>
            );
        }

        return (
            <Fragment>
                <ModalSelectCliente
                    usuario={this.state.usuario}
                    clientes={this.state.clientes}
                    modalSelectCliente={this.state.modalSelectCliente}

                    updateEmpresa={(empresa) => this.updateEmpresa(empresa)}
                    onClose={() => this.setState({modalSelectCliente: false})}
                />                
            </Fragment>
        )
    }

    render() {
        return (     
            <Fragment>   
                {this.showComponent()}                

                <ModalAlerta
                    show={this.state.erro.code !== 0}
                    texto={this.state.erro.message}

                    fechar={() => this.setState({erro: this.finalizaErro(this.state.erro)})}
                />

                <TopNav 
                    preload={this.inPreload()}
                    menu={this.state.menu}
                    usuario={this.state.usuario}
                    
                    updateEmpresa={(empresa) => this.updateEmpresa(empresa)}

                    route={item => this.browserRoute.history.push(item.link) }
                />

                <div id="layoutSidenav">
                    <SideNav      
                        preload={this.inPreload()}
                        menu={this.state.menu}
                        usuario={this.state.usuario}
                        changeEmpresa={this.state.clientes.length > 2}

                        route={item => this.browserRoute.history.push(item.link) }
                        onClick={() => this.setState({modalSelectCliente: true})}                        
                    />

                    <div id="layoutSidenav_content">                                                                                                                                                           
                        <BrowserRouter ref={(ref) => this.browserRoute =  ref}>
                            <Switch>  
                                <Route 
                                    exact
                                    path={getAppDir()}                                    
                                />

                                <Route 
                                    exact 
                                    path={getAppDir() + 'register'}
                                    render={props => 
                                        <Register
                                            {...props}
                                             
                                            usuario={this.state.usuario}

                                            route={(item) => this.browserRoute.history.push(item.link)}
                                        />
                                    }
                                /> 

                                <Route 
                                    exact 
                                    path={getAppDir() + 'login'}
                                    render={props => 
                                        <Login
                                            {...props}
                                                
                                            usuario={this.state.usuario}

                                            route={(item) => this.browserRoute.history.push(item.link)}
                                        />
                                    }
                                /> 
                                
                                <Route 
                                    exact 
                                    path={getAppDir() + 'notificacao'}
                                    render={props => 
                                        <NotificacaoPesquisa
                                            {...props}
                                               
                                            usuario={this.state.usuario}
                                            preload={this.inPreload()}

                                            route={(item) => this.browserRoute.history.push(item.link)}
                                        />
                                    }
                                />                                

                                <Route                                     
                                    path={getAppDir() + 'notificacao/crud'}
                                    render={props => 
                                        <NotificacaoCadastro
                                            {...props}
                                                            
                                            usuario={this.state.usuario}
                                            preload={this.inPreload()}

                                            route={(item) => this.browserRoute.history.push(item.link)}
                                        />
                                    }
                                />                                  

                                <Route 
                                    exact 
                                    path={getAppDir() + 'configuracao/tema'}
                                    render={props => 
                                        <TemaPesquisa
                                            {...props}
                                            
                                            usuario={this.state.usuario}
                                            preload={this.inPreload()}

                                            route={(item) => this.browserRoute.history.push(item.link)}
                                        />
                                    }
                                />                                                                 

                                <Route                                     
                                    path={getAppDir() + 'configuracao/tema/crud'}
                                    render={props => 
                                        <TemaCadastro
                                            {...props}
                                             
                                            usuario={this.state.usuario}
                                            preload={this.inPreload()}

                                            route={(item) => this.browserRoute.history.push(item.link)}
                                        />
                                    }
                                />                                  

                                <Route 
                                    exact 
                                    path={getAppDir() + 'configuracao/sistema'}
                                    render={props => 
                                        <Sistema
                                            {...props}
                                              
                                            usuario={this.state.usuario}
                                            preload={this.inPreload()}

                                            route={(item) => this.browserRoute.history.push(item.link)}
                                        />
                                    }
                                />                                               

                                <Route      
                                    exact                               
                                    path={getAppDir() + 'configuracao/formas-pagamento'}
                                    render={props => 
                                        <FormasPagamentoPesquisa
                                            {...props}
                                             
                                            usuario={this.state.usuario}
                                            preload={this.inPreload()}

                                            route={(item) => this.browserRoute.history.push(item.link)}
                                        />
                                    }
                                />  

                                <Route                                     
                                    path={getAppDir() + 'configuracao/formas-pagamento/crud'}
                                    render={props => 
                                        <FormasPagamentoCadastro
                                            {...props}
                                             
                                            usuario={this.state.usuario}
                                            preload={this.inPreload()}

                                            route={(item) => this.browserRoute.history.push(item.link)}
                                        />
                                    }
                                />   

                                <Route         
                                    exact                            
                                    path={getAppDir() + 'pedido'}
                                    render={props => 
                                        <Pedido
                                            {...props}
                                             
                                            usuario={this.state.usuario}
                                            preload={this.inPreload()}

                                            route={(item) => this.browserRoute.history.push(item.link)}
                                        />
                                    }
                                />                                                                                                                                          

                                <Route                                     
                                    path={getAppDir() + 'pedido/view'}
                                    render={props => 
                                        <PedidoView
                                            {...props}
                                             
                                            usuario={this.state.usuario}
                                            preload={this.inPreload()}

                                            route={(item) => this.browserRoute.history.push(item.link)}
                                        />
                                    }
                                />  

                                <Route 
                                    path={getAppDir()+ "*"}
                                    render={props => 
                                        <NaoEncontrado 
                                            {...props}                                                     
                                            
                                            erro={this.state.textoAlerta} 

                                            route={item => this.browserRoute.history.push(item.link) }
                                        /> 
                                    }
                                />  
                            </Switch>
                        </BrowserRouter>                                                                    
                    </div>
                </div>                
            </Fragment>          
        )
    }
}

export default Admin;